<template>
    <popup class="gc-popup-logout-confirmation" v-if="visible" :visible="visible" @hide="closePopup">
        <popup-title class="gc-popup-logout-confirmation__title">
            <popup-button-close @click="closePopup"></popup-button-close>
        </popup-title>

        <popup-body>
            <popup-head class="gc-popup-logout-confirmation__heading">
                <popup-text-heading :size="'md2'"  weight="extra-bold" class="text-center">{{$t('message["auth.logout-popup.header"]')}}</popup-text-heading>
            </popup-head>
            <popup-content class="gc-popup-logout-confirmation__content">
                <popup-text-body class="gc-popup-logout-confirmation__description text-center">{{$t('message["auth.logout-popup.description"]')}}</popup-text-body>
            </popup-content>

            <popup-footer class="gc-popup-logout-confirmation__footer">
                <button-primary :text="$t('message[\'auth.log-out\']')" @click="confirmed"></button-primary>
                <button-secondary :text="$t('message[\'general.cancel\']')" @click="closePopup"></button-secondary>
            </popup-footer>
        </popup-body>
    </popup>
</template>

<script>
import popupAnimationMixin from '../../../mixins/popupAnimationMixin'
import PopupTitle from './popup-sub-components/PopupTitle'
import PopupBody from './popup-sub-components/PopupBody'
import PopupHead from './popup-sub-components/PopupHead'
import PopupContent from './popup-sub-components/PopupContent'
import PopupFooter from './popup-sub-components/PopupFooter'
import ButtonPrimary from '../buttons/ButtonPrimary'
import ButtonSecondary from '../buttons/ButtonSecondary'
import PopupButtonClose from './popup-sub-components/PopupButtonClose'
import PopupTextBody from './popup-sub-components/PopupTextBody'
import PopupTextHeading from './popup-sub-components/PopupTextHeading'
import Popup from './Popup'
import TextContent from '../../root/TextContent'
import DashboardService from "@/services/DashboardService";
import AuthService from "@/services/AuthService";

export default {
  name: 'PopupLogoutConfirmation',
  mixins: [popupAnimationMixin],
  components: {
    Popup,
    PopupTitle,
    PopupHead,
    PopupBody,
    PopupContent,
    PopupFooter,
    PopupButtonClose,
    ButtonPrimary,
    TextContent,
    PopupTextBody,
    PopupTextHeading,
    ButtonSecondary
  },
  props: ['visible'],
  methods: {
    async confirmed () {
      const service = new DashboardService();
      const auth = new AuthService()
      try{
        const pwa  = auth.isMember()? service.config.config.pwa_app_id : service.config.config.pwa_app_id
        this.$OneSignal.init(
          {
            appId: pwa,
            welcomeNotification: {
              disable: true
            },
          }
        )
      } catch (e) {
        console.error(e)
      }



      try {
        console.log('PushSubscription.optedIn',this.$OneSignal.User.PushSubscription.optedIn)
        await this.$OneSignal.User.PushSubscription.optOut()
        await this.$OneSignal.User.PushSubscription.optOut()
        await this.$OneSignal.logout();
      } catch (e) {
        console.error(e)
      } finally {
        this.$emit('confirm')
      }


    },
    closePopup (e) {
      this.closeAnimatedPopup(() => {
        this.$emit('close')
      })
    }
  }
}
</script>
